import React from 'react';
import LogoImg from 'assets/Frame.svg';
import { Link } from 'react-router-dom';

export function Logo({ className = 'text-xl' }) {
  return (
    <Link to="/">
      <img src={LogoImg} alt="Chikwafu logo" className="h-10" />
    </Link>
  );
}
